export default "__VITE_ASSET__DrR5LBlx__"